// base styles
import boxShadows from "assets/mavric-theme/base/boxShadows";
import typography from "assets/mavric-theme/base/typography";
import colors from "assets/mavric-theme/base/colors";
import borders from "assets/mavric-theme/base/borders";

// helper functions
import pxToRem from "assets/mavric-theme/functions/pxToRem";

const { lg } = boxShadows;
const { size } = typography;
const { text, primary } = colors;
const { borderRadius } = borders;

const menu = {
  defaultProps: {
    disableAutoFocusItem: true,
  },

  styleOverrides: {
    paper: {
      // minWidth: pxToRem(80),
      boxShadow: lg,
      padding: `${pxToRem(4.8)} ${pxToRem(4.8)}`,
      fontSize: size.xs,
      color: text.main,
      textAlign: "left",
      backgroundColor: `${primary.light} !important`,
      borderRadius: borderRadius.md,
    },
  },
};

export default menu;
